const id_trans_convertion = {
    "": "konversi",
    add: "tambah konversi",
    name: "nama konversi",
    name_search: "Cari Nama Konversi",
    goods_conv: "konversi barang",
    goods_list: "daftar konversi barang",

    label: {
        goods_orig: "barang asal",
        goods_dest: "barang konversi",
    },

    message: {
        download_excel: "Unduh contoh file EXCEL upload Serial Number",
    },

    error: {
        create: "Gagal melakukan konversi",
        stock_orig: "Jumlah barang yang akan dikonversi tidak mencukupi",
        stock_conv: "Jumlah barang yang akan dikonversi tidak sesuai",
        sn_qty: "Kuantitas melebihi total barang yang diperlukan",
    },

    success: {
        create: "Berhasil melakukan konversi",
    },
}

export default id_trans_convertion;